import { Fragment } from "react";

import ScrollReveal from "@/blueprint/components/ScrollReveal/ScrollReveal";
import Section from "@/blueprint/components/Section/Section";
import Text from "@/blueprint/components/Text/Text";
import { HSA_FSA_DATES } from "@/views/hsa-fsa/hsaFsaContent";

const HsaFsaDates = ({ position }: { position: number }) => (
  <Section
    id="hsa-fsa-dates"
    position={position}
    ariaLabelledBy="hsa-fsa-dates-heading"
    className="flex flex-col items-center gap-[40px] bg-brand-teal-deep px-grid-margin py-[72px] tab:gap-[56px] tab:py-[96px] sd:gap-[64px] sd:py-[128px] d:gap-[80px]"
  >
    <ScrollReveal className="flex flex-col items-center gap-[12px] text-center text-brand-white tab:gap-[16px] sd:gap-[20px] d:gap-[24px]">
      <Text variant="h3" as="h2" tone="inherit">
        <span id="hsa-fsa-dates-heading">{HSA_FSA_DATES.headline}</span>
      </Text>
      <Text
        variant="paragraph-lg"
        tone="inherit"
        className="text-tint-white-70"
      >
        {HSA_FSA_DATES.subhead}
      </Text>
    </ScrollReveal>

    <ul className="flex w-full max-w-[366px] justify-center gap-[20px] tab:w-auto tab:max-w-none tab:gap-[56px] sd:gap-[64px] d:gap-[80px]">
      {HSA_FSA_DATES.dates.map((date, index) => (
        <li key={date.id} className="min-w-0 flex-1 tab:flex-none">
          <ScrollReveal
            className="flex w-full flex-col items-center gap-[12px] tab:w-[233px] sd:w-[254px] sd:gap-[16px] d:gap-[20px]"
            delayMs={index * 80}
          >
            {/* Centred rather than Figma's left alignment, by design decision. */}
            <div className="flex size-[124px] flex-col items-center justify-center gap-[8px] rounded-hsa-date-card bg-surface-cream p-[16px] text-center tab:size-[158px] tab:gap-[12px] tab:p-[20px] sd:size-[190px] sd:gap-[16px] sd:p-[24px] d:size-[254px] d:gap-[20px] d:p-[32px]">
              <p className="font-ppMori text-hsa-date-label font-semibold text-content-primary">
                {date.month}
              </p>
              <p className="font-ppMori text-hsa-date-number font-semibold text-content-primary">
                {date.day}
              </p>
            </div>
            <p className="text-balance text-center font-ppMori text-hsa-date-caption font-normal text-brand-white">
              {date.caption.map((line, lineIndex) => (
                <Fragment key={line.map((run) => run.text).join("")}>
                  {lineIndex > 0 && <br />}
                  {line.map((run) =>
                    "bold" in run ? (
                      <strong key={run.text} className="font-bold">
                        {run.text}
                      </strong>
                    ) : (
                      <Fragment key={run.text}>{run.text}</Fragment>
                    ),
                  )}
                </Fragment>
              ))}
            </p>
          </ScrollReveal>
        </li>
      ))}
    </ul>
  </Section>
);

export default HsaFsaDates;
